import * as React from 'react';
// @ts-expect-error
import {Controller} from 'react-hook-form';
// @ts-expect-error
import type {Control, Watch} from 'react-hook-form';

import {EditableFormField} from 'shells/form/editable-form-field';
import {FormField} from 'shells/form/form-field';
import {TextField} from 'shells/textfield/textfield';

import {getInputStyles} from '../../../../helpers';
import type {ElementType} from '../../../../types';

import {useFocusInput} from './use-focus-input';

type Props = {
    control: Control;
    name: string;
    watch: Watch;
    isActive: boolean;
    activeElement: ElementType | null | undefined;
};

export function TextfieldField(props: Props) {
    const [shouldFocusOnMount, setShouldFocusOnMount] = React.useState<boolean>(
        Boolean(props.isActive && props.activeElement && props.activeElement === 'label')
    );
    const [shouldFocusInputOnMount, setShouldFocusInputOnMount] = React.useState<boolean>(
        Boolean(props.isActive && props.activeElement && props.activeElement === 'input')
    );
    const isRequired = props.watch(`${props.name}.isRequired`);
    const color = props.watch('inputStyle.color');
    const inputColor = props.watch('inputStyle.inputColor');
    const fontSize = props.watch('inputStyle.fontSize');
    const border = props.watch('inputStyle.border');
    const borderRadius = props.watch('inputStyle.borderRadius');
    const label = props.watch(`${props.name}.label`);

    const textfieldRef = React.useRef(null);

    useFocusInput(textfieldRef, shouldFocusInputOnMount, setShouldFocusInputOnMount);

    return (
        <div style={{fontSize: `${fontSize}px`}}>
            <Controller
                name={`${props.name}.label`}
                control={props.control}
                rules={{
                    maxLength: {
                        value: 255,
                        message: 'Field names can’t exceed 255 characters',
                    },
                }}
                // @ts-expect-error
                render={({field, fieldState}) => {
                    const errorMessage = fieldState.error ? fieldState.error.message : undefined;

                    return (
                        <EditableFormField
                            innerId={field.id}
                            label={label}
                            errorMessage={errorMessage}
                            smallBottomMargin={true}
                            editableLabelProps={{
                                onSaveNewValue: (newName) => {
                                    field.onChange(newName);

                                    return new Promise((resolve) => {
                                        // @ts-expect-error
                                        resolve();
                                    });
                                },
                                placeholder: 'Add a title',
                                allowSavingEmpty: false,
                                shouldAllowUndo: false,
                                required: isRequired,
                                tooltip: null,
                                // @ts-expect-error
                                customStyle: {color},
                                isWhite: true,
                                shouldFocusOnMount,
                                onFocusedOnMount: () => setShouldFocusOnMount(false),
                            }}
                            isActive={props.isActive}
                            onEditField={() => {
                                if (textfieldRef.current) {
                                    // @ts-expect-error
                                    textfieldRef.current.focus();
                                }
                            }}
                        >
                            <Controller
                                name={`${props.name}.placeholder`}
                                control={props.control}
                                rules={{
                                    maxLength: {
                                        value: 255,
                                        message: 'Placeholders can’t exceed 255 characters',
                                    },
                                }}
                                render={({
                                    // @ts-expect-error
                                    field: textFieldField,
                                    // @ts-expect-error
                                    fieldState: textFieldFieldState,
                                }) => {
                                    const textFieldErrorMessage = textFieldFieldState.error
                                        ? textFieldFieldState.error.message
                                        : undefined;

                                    return (
                                        <FormField
                                            innerId='placeholder'
                                            errorMessage={textFieldErrorMessage}
                                        >
                                            <TextField
                                                value={textFieldField.value}
                                                // @ts-expect-error
                                                style={getInputStyles({
                                                    borderRadius,
                                                    border,
                                                    fontSize,
                                                    color,
                                                    inputColor,
                                                })}
                                                onChange={(newPlaceholder) => {
                                                    textFieldField.onChange(newPlaceholder);

                                                    return new Promise((resolve) => {
                                                        // @ts-expect-error
                                                        resolve();
                                                    });
                                                }}
                                                selectOnFocus={true}
                                                textFieldRef={(ref) => {
                                                    // @ts-expect-error
                                                    textfieldRef.current = ref;
                                                }}
                                            />
                                        </FormField>
                                    );
                                }}
                            />
                        </EditableFormField>
                    );
                }}
            />
        </div>
    );
}
